"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.materializeBorrowingBaseReportArtifacts = void 0;
const remeda_1 = require("remeda");
const common_1 = require("@finley-technologies/common");
const dbNodes = __importStar(require("../dbNodes/dbNodes"));
const utils = __importStar(require("../dbNodes/utils"));
const materializeBorrowingBaseReportArtifacts = (dbGraph) => {
    const { dataTapes, dataTapeDependencies } = dbGraph;
    const borrowingBaseReports = utils.filterBorrowingBaseReports({ dataTapes });
    const tempDataTapes = utils.removeArtifactsByTypes({
        dataTapes,
        types: ['borrowingBaseReport'],
    });
    const updatedBorrowingBaseReports = (0, remeda_1.map)(borrowingBaseReports, (borrowingBaseReport) => {
        const { id: borrowingBaseReportArtifactId } = borrowingBaseReport;
        const deps = (0, remeda_1.filter)(dataTapeDependencies, ({ outputArtifactId }) => outputArtifactId === borrowingBaseReportArtifactId);
        const depTapes = (0, remeda_1.map)(deps, ({ inputArtifactId }) => utils.findArtifactById({ artifactId: inputArtifactId, dataTapes }));
        const receivableResponseTapes = utils.filterReceivableResponseTapes({
            dataTapes: depTapes,
        });
        const cashResponseTapes = utils.filterCashResponseTapes({
            dataTapes: depTapes,
        });
        (0, common_1.finleyAssert)(receivableResponseTapes.length === 1, 'BorrowingBaseReport can only be created from a single receivable response tape');
        (0, common_1.finleyAssert)(cashResponseTapes.length <= 1, 'BorrowingBaseReport can only be created from 0 or 1 cashResponseTape');
        const receivableResponseTape = receivableResponseTapes[0];
        (0, common_1.finleyAssert)(receivableResponseTape.creditFacilitySlug, 'receivableResponseTape creditFacilitySlug must be defined');
        const { creditFacilitySlug, artifactSlug: receivableResponseTapeArtifactSlug, } = receivableResponseTape;
        const cashResponseTapeArtifactSlug = cashResponseTapes.length
            ? cashResponseTapes[0].artifactSlug
            : null;
        (0, common_1.finleyAssert)(dbNodes.borrowingBaseReport.isNode(borrowingBaseReport), 'borrowing base report is invalid');
        return {
            ...borrowingBaseReport,
            creditFacilitySlug,
            loanProductSlug: null,
            externalFilename: null,
            configuration: {
                ...borrowingBaseReport.configuration,
                receivableResponseTapeArtifactSlug,
                cashResponseTapeArtifactSlug,
            },
        };
    });
    return {
        dataTapeDependencies,
        dataTapes: [...tempDataTapes, ...updatedBorrowingBaseReports],
    };
};
exports.materializeBorrowingBaseReportArtifacts = materializeBorrowingBaseReportArtifacts;
//# sourceMappingURL=borrowingBaseReport.js.map